import Vue from 'vue'
import CurrentUser from '@/store/models/current-user'
import PermissionDefinition from '@/lib/permission-definition'
// import app from '@/lib/app'
export default class VueBase extends Vue {
	// L(value:string,source?:string,...argus:string[]):string{
	//     if(source){
	//         return window.abp.localization.localize(value,source,argus);
	//     }else{
	//         return window.abp.localization.localize(value,appconst.localization.defaultLocalizationSourceName,argus);
	//     }
	// }
	// 权限定义
	permissionDefinition = PermissionDefinition

	public hasPermission(permission: string) {
		let permissions: Array<string> = JSON.parse(window.sessionStorage.getItem('permission')!)
		if (permissions === null) {
			this.$store.dispatch('permission/getCurrentUserPermissionKeys')

			permissions = JSON.parse(window.sessionStorage.getItem('permission')!)
		}
		return permissions.findIndex(t=> t.toLowerCase() === permission.toLowerCase()) > -1
	}
	public hasAnyOfPermissions(...argus: string[]) {
		if (!argus || argus.length === 0)
			return false
		let permissions: Array<string> = this.$store.state.permission.currentUserPermissionKeys
		return permissions.some(t=> argus.indexOf(t) > 0)
	}
	public hasAllOfPermissions(...argus: string[]) {
		if (!argus || argus.length === 0)
			return false
		let permissions: Array<string> = this.$store.state.permission.currentUserPermissionKeys
		return !permissions.some(t=> argus.indexOf(t) < 0)
	}

	// 保留三位
	public roundingThreeFormat(cellValue: any) {
		if (!cellValue) return '0.000'
		return cellValue.toFixed(3)
	}

	// 保留两位
	public roundingTwoFormat(cellValue: any) {
		if (!cellValue) return '0.00'
		return cellValue.toFixed(2)
	}

	// 获取当前的用户信息
	public async getCurrentUser(): Promise<CurrentUser> {
		return await this.$store.dispatch('app/getCurrentUser')
	}
}
